module.exports = __webpack_public_path__ + "img/plan-3.eadfa763.png";